import { useEffect } from 'react';
import { audioCueService } from 'modules/audioCueService';
import { useToolPreferences } from 'hooks/usePreferences';
import { FF, useFeatureFlagEnabled } from 'modules/feature-flags';
import type { WithApolloContext } from 'modules/Apollo/types';

export const useAudioCueServiceSync = ({ context }: WithApolloContext): void => {
  const [isAudioCuesEnabled, loading] = useFeatureFlagEnabled(FF.REPORTER_DICTATION_AUDIO_CUES);
  const [toolPreferences] = useToolPreferences({ context });
  const playAudioCues = toolPreferences?.dictaphone.playAudioCues?.startStopRecording;

  useEffect(() => {
    if (playAudioCues === undefined || loading) return;
    audioCueService.setEnabled(isAudioCuesEnabled && playAudioCues);
  }, [isAudioCuesEnabled, playAudioCues, loading]);
};
